import React from 'react';
import { Navigate } from 'react-router-dom';

function ProtectedAuthRoute (props: any) {

    const { user, children } = props;

    if (user.isSigned === true && user.userConfirmed === true) {
        return <Navigate to={"/dashboard/orders"} replace />;
    }

    return children;
};

export default ProtectedAuthRoute;
